var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"step-tooltip"},[_c('div',{staticClass:"step-tooltip__text",class:{ 'step-tooltip__text--blue': _vm.blue }},[_c('FontAwesomeIcon',{staticClass:"step-tooltip__icon",class:{ 'step-tooltip__icon--show': _vm.iconVisible },attrs:{"icon":"info-circle"}}),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }